import React from "react";
import { useTranslation } from "next-i18next";

import useMediaQuery from "@vahak/core-ui/dist/hooks/useMediaQuery";

import { getPlatformStatI18nLabels } from "@vahak/core/dist/constants/platformStats";

import AppImg from "../../../../utils/AppImg";
import Swipper from "../../../../Swipper/Swipper";
import HomepageV2Animate from "../../../../homepage-v2/animate/HomepageV2Animate";
import HomepageV2SectionCard from "../../../../homepage-v2/section-card/HomepageV2SectionCard";
import WebV2SectionHeader from "../../../../homepage-v2/web-v2-section-header/WebV2SectionHeader";
import { MARKETPLACE_V3_ASSETS, MARKETPLACE_V3_MOBILE_CAROUSEL } from "../marketplaceV3.constants";
import Styles from "./MarketplaceV3BenefitsSection.module.scss";

type BenefitCard = { title: string; description: string };

const MarketplaceV3BenefitsSection = () => {
    const { t } = useTranslation("marketplaceV3");
    const isMobileScreen = useMediaQuery({ queryType: "mobile" });
    const cardsRaw = t("benefits.cards", { returnObjects: true, ...getPlatformStatI18nLabels() });
    const cards = (Array.isArray(cardsRaw) ? cardsRaw : []) as BenefitCard[];

    const renderCard = (card: BenefitCard, isCarousel = false) => (
        <article className={isCarousel ? Styles.cardCarousel : Styles.card}>
            <AppImg
                src={MARKETPLACE_V3_ASSETS.benefitCheckIcon}
                alt=""
                className={Styles.benefitIcon}
                width={36}
                height={36}
                placeholder="empty"
                unoptimized
                aria-hidden
            />
            <h3 className={Styles.cardTitle}>{card.title}</h3>
            <p className={Styles.cardDescription}>{card.description}</p>
        </article>
    );

    return (
        <HomepageV2SectionCard variant="white">
            <div className={Styles.container}>
                <HomepageV2Animate variant="fade-up">
                    <WebV2SectionHeader
                        title={t("benefits.title")}
                        description={t("benefits.description")}
                        align="left"
                        className={Styles.sectionHeader}
                        titleClassName={Styles.title}
                        descriptionClassName={Styles.description}
                    />
                </HomepageV2Animate>

                {isMobileScreen ? (
                    <Swipper
                        className={Styles.cardsSwiper}
                        {...MARKETPLACE_V3_MOBILE_CAROUSEL}
                        list={cards.map((card) => ({
                            key: card.title,
                            node: renderCard(card, true)
                        }))}
                    />
                ) : (
                    <div className={Styles.grid}>
                        {cards.map((card, index) => (
                            <HomepageV2Animate
                                key={card.title}
                                variant="fade-up"
                                delay={index * 90}
                                className={Styles.gridItem}
                            >
                                {renderCard(card)}
                            </HomepageV2Animate>
                        ))}
                    </div>
                )}
            </div>
        </HomepageV2SectionCard>
    );
};

export default MarketplaceV3BenefitsSection;
